module.exports = __webpack_public_path__ + "img/00020.401170e5.webp";